import { BasePage, type BasePageProps } from './BasePage'
import { PageProvider } from './context'
import { Header, SideMenu, BottomMenu, Content, ContentRow } from './components'

export type PageProps = BasePageProps

const Page = ({ children, sideMenuOptions, ...rest }: PageProps) => (
  <PageProvider sideMenuOptions={sideMenuOptions} hasSideMenu={!!rest.sideMenu} noPrintHeader={rest.noPrintHeader}>
    <BasePage {...rest}>{children}</BasePage>
  </PageProvider>
)

Page.BottomMenu = BottomMenu

/**
 * A container where we set the content distance based on the theme correctly.
 *
 * @example <Page><Page.Content isFullView>your application content</Page.Content></Page>
 */
Page.Content = Content

/**
 * Our mobile version is a full wide screen, this ContentRow can be used when
 * it does need indentation for a specific row. This indentation will only be
 * added on mobile variants.
 * @warning will add indentation only on MOBILE
 */
Page.ContentRow = ContentRow

Page.Header = Header

Page.SideMenu = SideMenu

export { Page }
